import React from 'react';

// The marketplace lockup (app: CLogo + logo_mark_on_{dark,light}.png): the
// gavel mark beside "Auction" with ".ai" set in DM Mono. Coral on the dark
// aura, brand red on light — both via the `accent` token. The mark is the
// design/icon-export gavel drawn in currentColor so it follows the same token.
export const GavelMark = ({ size = 28, className = '' }) => (
  <svg
    viewBox="0 0 120 120"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <g transform="translate(7.5,2)">
      <g transform="rotate(-45 52 52)">
        <rect x="7" y="34" width="90" height="34" rx="13" fill="currentColor" />
        <rect x="44" y="66" width="16" height="54" rx="8" fill="currentColor" />
      </g>
      <rect x="10" y="98" width="52" height="12" rx="6" fill="currentColor" />
      <g stroke="#F5B63F" strokeWidth="8" strokeLinecap="round">
        <line x1="66" y1="14" x2="74" y2="6" />
        <line x1="84" y1="34" x2="95" y2="30" />
        <line x1="14" y1="62" x2="6" y2="58" />
      </g>
    </g>
  </svg>
);

const Logo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: { mark: 24, text: 'text-lg' },
    md: { mark: 28, text: 'text-xl' },
    lg: { mark: 56, text: 'text-4xl' },
  };
  const s = sizes[size] || sizes.md;
  return (
    <span className={`inline-flex items-center gap-2 text-accent select-none ${className}`}>
      <GavelMark size={s.mark} />
      <span className={`${s.text} font-bold leading-none tracking-[-0.5px]`}>
        Auction<span className="font-mono">.ai</span>
      </span>
    </span>
  );
};

export default Logo;
